import React, { ButtonHTMLAttributes, ReactNode } from 'react'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { Link } from '@contrast-security-inc/design-system-typography'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
}

export function LinkButton({ className, ...props }: Props) {
  return (
    <button
      className={cx(
        css`
          outline: 0;
          background: ${theme.color.transparent};
          border: none;
          padding: 0;
          margin: 0;

          &:focus {
            text-decoration: underline;
          }
        `,
        className
      )}
      {...props}
    >
      <Link>{props.children}</Link>
    </button>
  )
}
